import React from "react";

export function SignUp() {
    return <div>
        Sign Up
    </div>
}